module.exports = __webpack_public_path__ + "static/media/3.af197ae3.png";